<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Panel Core';
                }
            },
            component_id: {
                default(){
                    return 'panel_core';
                }
            },
            panelCategory: {
              required: true,
            },
        },
        computed: {
            thumbURL(){
                return '/images/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/panel-core?panel_category=' + this.panelCategory;
            },
            cache_key(){
              return '_' + this.panelCategory;
            },
        },
        watch: {
          'cache_key': function (val, oldVal) {
            this.update_options();
          },
        }
    }
</script>
